import { Component, Input, OnInit, OutputEmitterRef } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { BudgetOptions } from 'src/app/core/constants-repository/project-calculation.constants';
import { SubSink } from 'subsink';
import {
  BUDGET_LABELS,
  RESET_BUDGET_LABELS,
} from '../../../../../../../core/text-db/project-calculation.text';
import { DropdownOption } from '../../../../../../../shared/data-types/dropdown-option';
import { recordToDropdownOptions } from '../../../../../../../shared/functions/dropdown-functions';

@Component({
  selector: 'app-project-calculation-form-reset-budget',
  templateUrl: './project-calculation-form-reset-budget.component.html',
  styleUrls: ['./project-calculation-form-reset-budget.component.scss'],
  standalone: false,
})
export class ProjectCalculationFormResetBudgetComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-output-readonly
  @Input() selectedBudgetRateOptionChanged: OutputEmitterRef<BudgetOptions>;
  public projectCalculationForm: FormGroup;
  public selectedBudgetOption: BudgetOptions;
  public budgetOptions$: Observable<DropdownOption[]>;
  public resetBudgetOptions$: Observable<DropdownOption[]>;
  public readonly BudgetOptions = BudgetOptions;
  private readonly subs = new SubSink();

  constructor(private readonly formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
    this.initEvents();
  }

  private buildForm(): void {
    this.projectCalculationForm = this.formBuilder.group({
      budgetGroup: this.formBuilder.group({
        budgetType: [
          {
            text: 'Kein Budget',
            value: 0,
          },
          Validators.required,
        ],
        budgetValue: [null, Validators.required],
      }),
      resetBudgetGroup: this.formBuilder.group({
        resetBudget: [null, Validators.required],
        resetBudgetFrequency: [null, Validators.required],
        resetBudgetAt: [null, Validators.required],
        resetBudgetValue: [null, Validators.required],
      }),
      exceedingBudgetGroup: this.formBuilder.group({
        exceedingBudgetWarning: [null, Validators.required],
        exceedingBudgetWarningEmail: [null, Validators.required],
        exceedingBudgetLimit: [null, Validators.required],
      }),
      billableRateGroup: this.formBuilder.group({
        billableRateType: [
          {
            text: 'Kein Verrechnungssatz',
            value: 0,
          },
          Validators.required,
        ],
        billableRateValue: [null, Validators.required],
      }),
    });
  }

  private initEvents(): void {
    this.budgetOptions$ = recordToDropdownOptions(BUDGET_LABELS);
    this.resetBudgetOptions$ = recordToDropdownOptions(RESET_BUDGET_LABELS);

    this.subs.sink = this.selectedBudgetRateOptionChanged.subscribe((option) => {
      this.selectedBudgetOption = option;
    });
  }
}
